import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './styles/hamburgermenu.css';

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setIsDropdownOpen(false);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close on route change
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Close on escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeMenu();
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const isActiveLink = (href) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname === href;
  };

  return (
    <>
      {/* Hamburger Button */}
      <button
        className={`hamburger-btn ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Backdrop */}
      {isOpen && (
        <div className="menu-backdrop" onClick={closeMenu} />
      )}

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <h2>Menu</h2>
          <button className="close-btn" onClick={closeMenu}>
            ✕
          </button>
        </div>

        <nav className="menu-nav">
          <a href="/" onClick={closeMenu} className={isActiveLink('/') ? 'active' : ''}>
            Hjem
          </a>
          
          <a href="/omos" onClick={closeMenu} className={isActiveLink('/omos') ? 'active' : ''}>
            Om Os
          </a>

          <div className="menu-dropdown">
            <button 
              className={`dropdown-btn ${isActiveLink('/tjenester') || isActiveLink('/hjemmesider') || isActiveLink('/seo') ? 'active' : ''}`}
              onClick={toggleDropdown}
            >
              Tjenester
              <span className={`arrow ${isDropdownOpen ? 'open' : ''}`}>▼</span>
            </button>
            
            {isDropdownOpen && (
              <div className="dropdown-content">
                <a href="/tjenester" onClick={closeMenu} className={isActiveLink('/tjenester') ? 'active' : ''}>
                  <strong>Alle Tjenester</strong>
                  <span>Se vores komplette serviceudbud</span>
                </a>
                <a href="/hjemmesider" onClick={closeMenu} className={isActiveLink('/hjemmesider') ? 'active' : ''}>
                  <strong>Hjemmesider</strong>
                  <span>Professionelle websites der konverterer</span>
                </a>
                <a href="/seo" onClick={closeMenu} className={isActiveLink('/seo') ? 'active' : ''}>
                  <strong>SEO</strong>
                  <span>Søgemaskineoptimering der virker</span>
                </a>
              </div>
            )}
          </div>

          <a href="/priser" onClick={closeMenu} className={isActiveLink('/priser') ? 'active' : ''}>
            Priser
          </a>
          
          <a href="/cases" onClick={closeMenu} className={isActiveLink('/cases') ? 'active' : ''}>
            Cases
          </a>
          
          <a href="/kontakt" onClick={closeMenu} className={isActiveLink('/kontakt') ? 'active' : ''}>
            Kontakt
          </a>
        </nav>
      </div>
    </>
  );
};

export default HamburgerMenu;